import React from 'react';
import { FileText, Download } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

interface Invoice {
  id: string;
  amount: number;
  currency: string;
  status: 'paid' | 'pending' | 'failed';
  created_at: string;
  invoice_url: string;
}

interface InvoiceListProps {
  invoices: Invoice[];
}

export function InvoiceList({ invoices }: InvoiceListProps) {
  if (invoices.length === 0) {
    return (
      <div className="text-center text-gray-400 py-8">
        No invoice available
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {invoices.map((invoice) => (
        <div 
          key={invoice.id}
          className="bg-white/5 backdrop-blur-xl rounded-lg p-4 border border-white/10 flex items-center justify-between"
        >
          <div className="flex items-center gap-4">
            <div className="w-10 h-10 rounded-lg bg-indigo-500/20 flex items-center justify-center">
              <FileText className="w-5 h-5 text-indigo-400" />
            </div>
            <div>
              <p className="text-white font-medium">
                Invoice from {format(new Date(invoice.created_at), 'dd MMMM yyyy', { locale: fr })}
              </p>
              <p className="text-gray-400">
                {new Intl.NumberFormat('fr-FR', {
                  style: 'currency',
                  currency: invoice.currency
                }).format(invoice.amount)}
              </p>
            </div>
          </div>

          <a
            href={invoice.invoice_url}
            target="_blank"
            rel="noopener noreferrer"
            className="p-2 text-gray-400 hover:text-white transition-colors"
            title="Télécharger la facture"
          >
            <Download className="w-5 h-5" />
          </a>
        </div>
      ))}
    </div>
  );
}